const hartfordCaseStudiesPage = `
{{#> hartford/NavLayout currentPage=currentPage Pages=Pages basePath=basePath logoUrl=project.values.logoUrl }}
  <div class="case-studies-container">
    <div class="case-studies-grid">
      {{#each pageContext.case_studies}}
        <div class="case-study-card">
          <!-- Title -->
          <h3 class="case-study-title">{{this.title}}</h3>

          <!-- Photo and Description -->
          <div class="case-study-top-row">
            <div class="person-photo">
              <img src="{{this.person_photo}}" alt="{{this.person_name}}" />
            </div>

            <div class="case-study-info">
              <div class="person-info">
                <div class="person-name">{{this.person_name}}</div>
                <div class="person-role">{{this.person_role}}</div>
              </div>

              <div class="case-study-description">
                {{this.description}}
              </div>
            </div>
          </div>

          <!-- Middle Row: Concerns, Solution, Results -->
          <div class="case-study-sections-row">
            <div class="section-item concerns-section">
              <h4 class="section-title">Concerns</h4>
              <p class="section-text">{{this.concerns}}</p>
            </div>

            <div class="section-item solution-section">
              <h4 class="section-title">Solution</h4>
              <p class="section-text">{{this.solution}}</p>
            </div>

            <div class="section-item results-section">
              <h4 class="section-title">Results</h4>
              <p class="section-text">{{this.results}}</p>
            </div>
          </div>

          <!-- Bottom Row: Savings -->
          <div class="case-study-bottom-row">
            <div class="savings-indicator">
              <div class="savings-amount">{{this.savings_per_year}}k</div>
              <div class="savings-label">Savings per year</div>
            </div>
          </div>
        </div>

        {{#unless @last}}
          <div class="case-study-divider"></div>
        {{/unless}}
      {{/each}}
    </div>
  </div>
{{/hartford/NavLayout}}
`;

const hartfordCaseStudyItem = `
<div class="case-study-card">
  <!-- Title -->
  <h3 class="case-study-title">{{this.title}}</h3>

  <!-- Photo and Description -->
  <div class="case-study-top-row">
    <div class="person-photo">
      <img src="{{this.person_photo}}" alt="{{this.person_name}}" />
    </div>

    <div class="case-study-info">
      <div class="person-info">
        <div class="person-name">{{this.person_name}}</div>
        <div class="person-role">{{this.person_role}}</div>
      </div>

      <div class="case-study-description">
        {{this.description}}
      </div>
    </div>
  </div>

  <!-- Middle Row: Concerns, Solution, Results -->
  <div class="case-study-sections-row">
    <div class="section-item concerns-section">
      <h4 class="section-title">Concerns</h4>
      <p class="section-text">{{this.concerns}}</p>
    </div>

    <div class="section-item solution-section">
      <h4 class="section-title">Solution</h4>
      <p class="section-text">{{this.solution}}</p>
    </div>

    <div class="section-item results-section">
      <h4 class="section-title">Results</h4>
      <p class="section-text">{{this.results}}</p>
    </div>
  </div>

  <!-- Bottom Row: Savings -->
  <div class="case-study-bottom-row">
    <div class="savings-indicator">
      <div class="savings-amount">{{this.savings_per_year}}k</div>
      <div class="savings-label">Savings per year</div>
    </div>
  </div>
</div>
`;

const hartfordCaseStudiesPageStyles = `
.case-studies-container {
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-header .section-title {
  font-size: 32px;
  font-weight: 700;
  color: #0066cc;
  margin-bottom: 20px;
  display: inline-block;
}

.section-header .section-description {
  font-size: 18px;
  color: #666;
  max-width: 700px;
  margin: 20px auto 0;
}

.case-studies-grid {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 10px 0 30px;
}

.case-study-card {
  display: flex;
  flex-direction: column;
  padding: 25px 0;
}

.case-study-divider {
  height: 1px;
  background: linear-gradient(to right, rgba(0, 102, 204, 0.05), rgba(0, 102, 204, 0.5), rgba(0, 102, 204, 0.05));
  margin: 50px 0;
  position: relative;
}

.case-study-divider:before {
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #0066cc;
  border-radius: 50%;
  top: -4px;
  left: 50%;
  transform: translateX(-50%);
}

.case-study-title {
  font-size: 24px;
  font-weight: 700;
  color: #0066cc;
  margin: 0 0 20px 0;
  padding: 0 25px;
}

/* Photo and Description */
.case-study-top-row {
  display: flex;
  padding: 0 25px 25px;
  margin-bottom: 25px;
}

.person-photo {
  width: 200px;
  height: 200px;
  overflow: hidden;
  margin-right: 30px;
  flex-shrink: 0;
}

.person-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.case-study-info {
  flex: 1;
}

.person-info {
  margin-bottom: 15px;
}

.person-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.person-role {
  font-size: 14px;
  color: #666;
  margin-top: 3px;
}

.case-study-description {
  font-size: 15px;
  line-height: 1.6;
  color: #555;
}

/* Middle Row: Concerns, Solution, Results */
.case-study-sections-row {
  display: flex;
  padding: 0 25px 25px;
  margin-bottom: 15px;
}

.section-item {
  flex: 1;
  padding-right: 25px;
}

.section-item:last-child {
  padding-right: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #0066cc;
  margin: 0 0 10px 0;
}

.section-text {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

/* Bottom Row: Savings */
.case-study-bottom-row {
  display: flex;
  justify-content: flex-end;
  padding: 0 25px;
}

.savings-indicator {
  text-align: right;
}

.savings-amount {
  font-size: 20px;
  font-weight: 700;
  color: #0066cc;
  line-height: 1.2;
}

.savings-label {
  font-size: 14px;
  color: #333;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .case-study-sections-row {
    flex-direction: column;
  }

  .section-item {
    padding-right: 0;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }

  .section-item:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
  }
}

@media (max-width: 576px) {
  .section-header .section-title {
    font-size: 28px;
  }

  .section-header .section-description {
    font-size: 16px;
  }

  .case-study-title {
    text-align: center;
  }

  .case-study-top-row {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .person-photo {
    width: 120px;
    height: 120px;
    margin-right: 0;
    margin-bottom: 20px;
  }

  .case-study-bottom-row {
    justify-content: center;
  }

  .savings-indicator {
    text-align: center;
  }
}
`;

export const caseStudiesBlocks: any[] = [
  {
    name: 'hartford/CaseStudiesPage',
    partial: hartfordCaseStudiesPage,
    css: hartfordCaseStudiesPageStyles,
  },
  {
    name: 'hartford/CaseStudyItem',
    partial: hartfordCaseStudyItem,
    css: hartfordCaseStudiesPageStyles,
  },
];
